import React from 'react';
import { IProps } from './type';

const RetryIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.793 11.7241L17.7971 7.01562L22.4995 9.01975"
        stroke={strokeColor || 'black'}
        strokeWidth="0.888889"
        strokeMiterlimit="10"
      />
      <path
        d="M18.039 7.35837C18.7453 8.60189 19.1437 10.0446 19.1437 11.5719C19.1437 16.3045 15.3045 20.1437 10.5719 20.1437C5.83923 20.1437 2 16.3105 2 11.5719C2 6.83319 5.83923 3 10.5719 3"
        stroke={strokeColor || 'black'}
        strokeWidth="0.888889"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default RetryIcon;
